import React, { useState, useRef, useEffect } from "react";
import {
  View,
  ScrollView,
  Text,
  Image,
  TouchableOpacity,
  SafeAreaView,
  ActivityIndicator,
  TextInput,
  Modal,
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import MobileHeader from "../components/mHeader";
import Footer from "../components/footer";
import InsideHeader from "../components/insideHeader";
import AsyncStorage from "../components/AsyncStorage";
import axios from "axios";
import { API_MIDDLEWARE, API_REGION } from "@env";
import i18n from "../components/i18n";
import CookieConsent from "../components/CookieConsent";
import NewMobileHeader from "../components/newMobileHeader";
import loyalty from "../api/loyalty";
import CaptchaConfirm from "../components/CaptchaConfirm";
import InternationalPhoneInput from "../components/IntlPhone";

let timer = () => { };
let otpInterval

const UpdateMobile = () => {
  const navigation = useNavigation();

  const [isLoading, setIsLoading] = useState(true);
  const [member, setMember] = useState("");
  const [memberRegion, setMemberRegion] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneErr, setPhoneErr] = useState(false);
  const [phoneUniqueErr, setPhoneUniqueErr] = useState(false);
  const [validPhone, setValidPhone] = useState(false);
  const [dialCode, setDialCode] = useState("");
  const [token, setToken] = useState("");
  const [tokenErr, setTokenErr] = useState(false);
  const [otpCount, setOtpCount] = useState(180);
  const [disableItem, setDisableItem] = useState(false);
  //const [otpSign, setOtpSign] = useState("");
  const [successOverlay, setSuccessOverlay] = useState(false);

  const [otpCode, setOtpCode] = useState("");
  const [otpStatus, setOtpStatus] = useState(0)
  const [otpError, setOtpError] = useState(false)
  const [otpError2, setOtpError2] = useState(false)
  const [otpError3, setOtpError3] = useState(false)
  const [otpError4, setOtpError4] = useState(false)
  const [otpCoutdown, setOptCountdown] = useState(180)
  const [captchaOverlay, setCaptchaOverlay] = useState(false)
  const [captchaImg, setCaptchaImg] = useState('')
  const [captchaCid, setCaptchaCid] = useState('')
  const [captchaErr, setCaptchaErr] = useState(false)
  const [otpSign, setOtpSign] = useState("");
  const [codeSent, setCodeSent] = useState(false)
  const [codeSentMsg, setCodeSentMsg] = useState("")

  useEffect(() => {
    startTimer();
    return () => clearTimeout(timer);
  });

  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;

    AsyncStorage.getData("mCode").then((value) => {
      if (!value) {
        navigation.push("Login");
      } else {
        let loginDetail = JSON.parse(value);
        setMemberRegion(loginDetail.region);

        let data = {
          code: loginDetail.code,
          username: loginDetail.username,
          region: loginDetail.region,
        };

        customerGet(data, (customer) => {
          console.log("customerGet :", customer);

          setMember(customer);

          setIsLoading(false);
        });
      }
    });
  }, []);

  const otpCaptcha = () => {
    let err = false;
    setPhoneErr(false);
    setPhoneUniqueErr(false);
    setIsLoading(true);
    setOtpError(false)
    setOtpError2(false)
    setOtpError3(false)
    setOtpError4(false)
    setCodeSent(false)

    if (!validPhone) {
      err = true;
      setPhoneErr(true);
    }

    if (!err) {
      let data = {
        mobile: dialCode + phone.replace(/\s/g, ""),
      };

      checkUnique(data, (unique) => {
        if (unique.status == "success") {
          let data2 = {
        method: "getCaptcha"
      }

          loyalty.api(data2).then((res) => {
        setCaptchaImg(res.url)
        setCaptchaCid(res.cid)
        setCaptchaOverlay(true)
        setOtpCode("")
        setIsLoading(false);
      })
    } else {
          setPhoneUniqueErr(true);
          setIsLoading(false);
          return;
        }
      })

    } else {
      setIsLoading(false)
    }
  }

  const sendOtp = (res) => {
    setIsLoading(true)
    setCaptchaOverlay(false)
    setCaptchaErr(false)
    setPhoneErr(false);
    setPhoneUniqueErr(false);
    setOtpError4(false)

        console.log("sendOtp")

        let data = {
          method: "sendotpv2",
          cid: captchaCid,
          captcha: res,
          target: phone.replace(/\s/g, ""),
          country_code: dialCode,
          channel: "sms",
          region: API_REGION
        }

        loyalty.api(data).then((res) => {
          if (res.status == "success") {
            setOtpSign(res.signature);
            setMemberRegion(res.region)
            setOtpStatus(1)
            setOptCountdown(180)
            //startCountdown(180)
            startCountdownV2(3)

            setCodeSentMsg(i18n.t("otp.success_sent_mobile"))
            setCodeSent(true)

            setIsLoading(false)
          } else if (res.message.indexOf("Please retry in") > -1) {
            setTimeout(() => {
              setOtpError4(true)
              setIsLoading(false)
            }, 1000)
          } else {
            setTimeout(() => {
              setCaptchaErr(true)
              setIsLoading(false)
              otpCaptcha()
            }, 1000)
          }
        })

  }

  const verifyOtp = async (callback) => {
    let data = {
      method: "verifyotp",
      sign: otpSign,
      code: otpCode,
      ismem: "0",
      region: API_REGION,
      channel: "sms",
      target: phone.replace(/\s/g, ""),
      country_code: dialCode,
    }

    await loyalty.api(data).then((res) => {
      callback(res)
    })
  }

  const startCountdown = (countdown) => {
    if (countdown != 0) {
      setTimeout(() => {
        let newCount = countdown - 1
        setOptCountdown(newCount)
        startCountdown(newCount)
      }, 1000)
    } else {
      setOtpStatus(2)
    }
  }

  const startCountdownV2 = (minutes) => {
    let targetTime = new Date();
    targetTime.setMinutes(targetTime.getMinutes() + minutes);

    const updateOtpCount = () => {
      const now = new Date();
      const timeRemaining = targetTime - now;

      if (timeRemaining <= 0) {
        clearInterval(otpInterval);
        setOtpStatus(2)
        return
      } else {
        const totalSeconds = Math.floor(timeRemaining / 1000);

        setOptCountdown(totalSeconds)
      }
    }

    updateOtpCount()
    otpInterval = setInterval(updateOtpCount, 1000);
  }

  const sendToken = () => {
    let errors = [];
    setPhoneErr(false);
    setPhoneUniqueErr(false);

    setIsLoading(true);

    if (!validPhone) {
      errors.push("err");
      setPhoneErr(true);
    }

    if (!errors.length) {
      let data = {
        mobile: dialCode + phone.replace(/\s/g, ""),
      };

      checkUnique(data, (unique) => {
        if (unique.status == "success") {
          let data = {
            channel: "sms",
            target: phone.replace(/\s/g, ""),
            country_code: dialCode,
          };

          sendOTP(data, (otp) => {
            if (otp.status == "success") {
              setOtpSign(otp.signature);
              setDisableItem(true);
              setOtpStatus(1);
              start();
            } else {
              alert(otp.message);
            }
          });

          setIsLoading(false);
        } else {
          setPhoneUniqueErr(true);
          setIsLoading(false);
        }
      });
    } else {
      setIsLoading(false);
    }
  };

  const updateMobile = async () => {
    setOtpError(false)
    setOtpError2(false)
    setOtpError3(false)
    setOtpError4(false)
    setCodeSent(false)
    setIsLoading(true);

    if (otpCode == "") {
      setOtpError2(true)
      setIsLoading(false);
    } else {
      await verifyOtp((res) => {
        if (res.status != "success") {
          setOtpError(true)
          setOtpCode("")
          setIsLoading(false);
        } else {
          if (res.message == "The OTP signature has been expired") {
            setOtpError3(true)
            setOtpCode("")
            setIsLoading(false);
          } else {
          let updateData = {
            code: member.code,
            phone: phone.replace(/\s/g, ""),
            country_code: dialCode,
          };

          updateCust(updateData, (update) => {
            if (update.status == "success") {
              let store = {
                code: member.code,
                username: dialCode + phone.replace(/\s/g, ""),
                region: API_REGION,
              };

              AsyncStorage.storeData("mCode", JSON.stringify(store));

              setSuccessOverlay(true);
              setIsLoading(false);
            } else {
              alert("Update Error");
              setIsLoading(false);
            }
          });
          }
        }
      })
    }
  };

  const startTimer = () => {
    timer = setTimeout(() => {
      if (otpCount <= 0) {
        clearTimeout(timer);
        setDisableItem(false);
        return false;
      }
      setOtpCount(otpCount - 1);
    }, 1000);
  };

  const start = () => {
    setOtpCount(180);
    clearTimeout(timer);
    startTimer();
  };

  const customerGet = (data, callback) => {
    let formdata = {
      method: "getCust",
      code: data.code,
      //username: data.username,
      region: data.region
    }

    loyalty.api(formdata).then((res) => {
      callback(res)
      })
  };

  const updateCust = (data, callback) => {
    let formdata = {
      method: "updateCust",
      code: data.code,
      mobilenocc: data.phone,
      country_code: data.country_code,
      region: API_REGION
    }

    loyalty.api(formdata).then((res) => {
      callback(res)
      })
  };

  const checkUnique = (data, callback) => {
    let formdata = {
      method: "checkDup",
      mobile: data.mobile,
      region: memberRegion
    }

    loyalty.api(formdata).then((res) => {
      callback(res)
      })
  };

  const sendOTP = (data, callback) => {
    let formdata = {
      method: "sendotp",
      channel: data.channel,
      target: data.target,
      region: memberRegion
    }

    if (data.country_code) {
      formdata.country_code = data.country_code
    }

    loyalty.api(formdata).then((res) => {
      callback(res)
      })
  };

  const verifyOTP = (data, callback) => {
    let formdata = {
      method: "verifyotp",
      channel: data.channel,
      target: data.target,
      sign: data.sign,
      code: data.code,
      region: memberRegion
    }

    if (data.country_code) {
      formdata.country_code = data.country_code
    }

    loyalty.api(formdata).then((res) => {
      callback(res)
      })
  };

  return (
    <SafeAreaView className="min-h-full bg-white md:bg-[#F5F5F5]">
      {isLoading && (
        <View
          className="absolute left-0 right-0 top-0 bottom-0 justify-center items-center bg-[#f3f3f394] z-10 w-full h-screen"
          pointerEvents={"none"}
        >
          <ActivityIndicator size="large" color={"#BD9B60"} />
        </View>
      )}
      <InsideHeader />
      <NewMobileHeader />
      <MobileHeader
        title={i18n.t("updateMobile.title")}
        backTo={"EditProfile"}
      />
      <ScrollView className="flex-1 h-auto">
        <View className="hidden md:flex md:w-4/5 max-w-7xl m-auto mt-6 mb-4 flex-row items-center">
          <Image
            className="w-4 h-4 mr-1"
            source={require("../assets/icons/icon-home.png")}
          />
          <TouchableOpacity onPress={() => navigation.push("Profile")}>
            <Text className="text-sm font-normal text-[#4E5969] font-PingFangSC">
              {i18n.t("updateMobile.member_profile")}
            </Text>
          </TouchableOpacity>
          <Text> / </Text>
          <Text className="font-PingFangSC">
            {i18n.t("updateMobile.updateMobile")}
          </Text>
        </View>
        <View className="flex w-full md:w-4/5 max-w-7xl m-auto bg-white p-5 flex-col">
          <View>
            <Text className="hidden md:flex text-2xl font-semibold text-black font-Crimson">
              {i18n.t("updateMobile.updateMobile")}
            </Text>
          </View>
          <View className="flex flex-col flex-wrap items-start justify-between pb-4">
            <Text className="text-[#4E5969] text-xs mt-4 mb-1 font-PingFangSC">
              {i18n.t("updateMobile.new_mobile")}
            </Text>
            <View className="w-full flex flex-row justify-around items-center">
              <View className="flex-1 mr-2">
                <InternationalPhoneInput setValidPhone={setValidPhone} setPhone={setPhone} setDialCode={setDialCode} />
              </View>

              {
                otpStatus == 0 &&
                <TouchableOpacity onPress={() => { otpCaptcha(); }} >
                  <View className="flex-1 h-9 max-h-9 bg-white border border-brandgold">
                    <Text className="text-brandgold h-9 leading-9 text-center font-PingFangSC uppercase px-4">{i18n.t("otp.send_code")}</Text>
                  </View>
                </TouchableOpacity>
              }
              {
                otpStatus == 1 &&
                <TouchableOpacity>
                  <View className="flex-1 h-9 max-h-9 bg-white border border-[#9E9E9E]">
                    <Text className="text-[#9E9E9E] h-9 leading-9 text-center font-PingFangSC uppercase px-4">{i18n.t("otp.resend_code")} <Text className="text-red-500 lowercase">({otpCoutdown}{i18n.t("otp.sec")})</Text></Text>
                  </View>
                </TouchableOpacity>
              }
              {
                otpStatus == 2 &&
                <TouchableOpacity onPress={() => { otpCaptcha(); }} >
                  <View className="flex-1 h-9 max-h-9 bg-white border border-brandgold">
                    <Text className="text-brandgold h-9 leading-9 text-center font-PingFangSC uppercase px-4">{i18n.t("otp.resend_code")}</Text>
                  </View>
                </TouchableOpacity>
              }
              {
                otpStatus == 3 &&
                <TouchableOpacity>
                  <View className="flex-1 h-9 max-h-9 bg-white border border-brandgold">
                    <Text className="text-brandgold h-9 leading-9 text-center font-PingFangSC uppercase px-4">✓</Text>
                  </View>
                </TouchableOpacity>

              }
              {/* <TouchableOpacity
                className="h-9 w-[130px] bg-[#F2F3F5] px-4 ml-3"
                onPress={() => sendToken()}
                disabled={disableItem}
              >
                {disableItem && (
                  <Text className="text-gray-400 w-full text-sm h-9 leading-9 text-center font-semibold font-PingFangSC">
                    {i18n.t("updateMobile.sent")}({otpCount})
                  </Text>
                )}
                {!disableItem && (
                  <Text className="text-[#121212] w-full text-sm h-9 leading-9 text-center font-semibold font-PingFangSC">
                    {i18n.t("updateMobile.send_token")}
                  </Text>
                )}
              </TouchableOpacity> */}
            </View>

            {phoneErr && (
              <Text className="color-red-500 my-1">
                {i18n.t("updateMobile.mobile_errMsg1")}
              </Text>
            )}
            {phoneUniqueErr && (
              <Text className="color-red-500 my-1">
                {i18n.t("updateMobile.mobile_errMsg2")}
              </Text>
            )}

            <Text className="text-[#4E5969] text-xs mt-4 mb-1 font-PingFangSC">
              {i18n.t("otp.verification_code")}
            </Text>

            <View className="w-full flex flex-row justify-around">
            <TextInput
              placeholder=""
              className="h-9 w-full bg-[#F2F3F5] color-[#121212] px-4"
                value={otpCode}
                onChangeText={setOtpCode}
            ></TextInput>
            </View>

            {otpError && <Text className="color-red-500 my-1">{i18n.t("otp.err_verify")}</Text>}
            {otpError2 && <Text className="color-red-500 my-1">{i18n.t("otp.err_login")}</Text>}
            {otpError3 && <Text className="color-red-500 my-1">{i18n.t("otp.err_expired")}</Text>}
            {otpError4 && <Text className="color-red-500 my-1">{i18n.t("otp.please_retry")}</Text>}
            {codeSent ? <Text className="color-green-500 my-1">{codeSentMsg}</Text> : null}

            {tokenErr && (
              <Text className="color-red-500 my-1">
                {i18n.t("updateMobile.token_error")}
              </Text>
            )}

            <View className="flex flex-row flex-wrap justify-start items-start w-full my-auto mt-6">
              <TouchableOpacity
                className="w-full md:w-auto md:max-w-[125px] h-8 max-h-8 bg-brandgold mt-9 mr-3 px-4"
                onPress={() => updateMobile()}
              >
                <Text className="text-white w-full h-8 leading-8 text-center font-semibold font-PingFangSC">
                  {i18n.t("updateMobile.update")}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </ScrollView>

      {successOverlay && (
        <View
          className="top-0 right-0 bottom-0 left-0 justify-center items-center bg-[#00000075]"
          style={{ position: "fixed" }}
        >
          <View className="w-11/12 max-w-xs bg-white px-6 py-3 relative">
            <TouchableOpacity
              className="absolute right-1 top-1"
              onPress={() => {
                setSuccessOverlay(false);
                navigation.push("EditProfile");
              }}
            >
              <Image
                className="w-5 h-5"
                source={require("../assets/btn-close.png")}
              />
            </TouchableOpacity>

            <Text className="text-xl font-semibold text-[#111111] text-center py-8 uppercase font-Crimson">
              {i18n.t("updateMobile.update_success")}
            </Text>

            <View className="text-right flex items-end mb-8">
              <TouchableOpacity
                className="w-full h-8 max-h-8 bg-brandgold mt-4 mr-0"
                onPress={() => {
                  setSuccessOverlay(false);
                  navigation.push("EditProfile");
                }}
              >
                <Text className="text-white w-full h-8 leading-8 text-center font-normal font-PingFangSC">
                  {i18n.t("updateMobile.done")}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      )}

      <Footer />
      <CookieConsent />

      {captchaOverlay &&
        <CaptchaConfirm closeBtnAction={() => setCaptchaOverlay(false)} callback={(res) => sendOtp(res)} captchaImg={captchaImg} captchaErr={captchaErr}
        />
      }
    </SafeAreaView>
  );
};

export default UpdateMobile;
